module.exports = __webpack_public_path__ + "assets/img/bmy-a.8895c2e2.png";